export enum ViewMode {
  NORMAL = 'normal',
  EDIT_UNCHANGED = 'edit_unchanged',
  EDIT = 'edit',
  SCHEDULE_UNCHANGED = 'schedule-unchanged',
  SCHEDULE = 'schedule',
  UPDATING = 'updating',
  AWAITING = 'awaiting',
  OFFLINE = 'offline',
}

export enum PendingUpdateAction {
  NONE = 'none',
  AWAIT_LOCAL_UPDATE = 'await-local-update',
  AWAIT_EXTERNAL_UPDATE = 'await-external-update',
  COMPLETE_UPDATE = 'complete-update',
  IGNORE_STALE_PENDING = 'ignore-stale-pending',
}

interface PendingUpdateState {
  viewMode: ViewMode;
  hasPendingUpdates: boolean;
  recoveringFromFailedUpdate: boolean;
}

interface PendingUpdateResolution {
  action: PendingUpdateAction;
  recoveringFromFailedUpdate: boolean;
}

export function resolvePendingUpdateState({
  viewMode,
  hasPendingUpdates,
  recoveringFromFailedUpdate,
}: PendingUpdateState): PendingUpdateResolution {
  if (hasPendingUpdates) {
    if (recoveringFromFailedUpdate) {
      return {
        action: PendingUpdateAction.IGNORE_STALE_PENDING,
        recoveringFromFailedUpdate: true,
      };
    }
    if (viewMode === ViewMode.UPDATING) {
      return {
        action: PendingUpdateAction.AWAIT_LOCAL_UPDATE,
        recoveringFromFailedUpdate: false,
      };
    }
    if (viewMode !== ViewMode.AWAITING) {
      return {
        action: PendingUpdateAction.AWAIT_EXTERNAL_UPDATE,
        recoveringFromFailedUpdate: false,
      };
    }
    return {
      action: PendingUpdateAction.NONE,
      recoveringFromFailedUpdate: false,
    };
  }

  return {
    action:
      viewMode === ViewMode.AWAITING
        ? PendingUpdateAction.COMPLETE_UPDATE
        : PendingUpdateAction.NONE,
    recoveringFromFailedUpdate: false,
  };
}
